import { gql } from "@apollo/client";

const BORRAR_DOCUMENTOS_RECLAMO = gql`
    mutation borrarDocumentoReclamo($idArchivo: Int!){
        borrarDocumentoReclamo(idArchivo: $idArchivo){
            success
        }
    }
`;

export default BORRAR_DOCUMENTOS_RECLAMO;